import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileShorthand,
  editProfileShorthand,
  listProfileShorthandByProfileId,
  removeProfileShorthand,
} from "./thunkAction";

const initialState = {
  profileShorthands: [],
  loading: false,
  error: null,
  isLoadingAddProfileShorthand: false,
  addProfileShorthandError: null,
};

const profileShorthandSlice = createSlice({
  name: "profileShorthandManage",
  initialState,
  reducers: {
    clearProfileShorthand(state) {
      state.profileShorthands = [];
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // listProfileShorthandByProfileId
      .addCase(listProfileShorthandByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(listProfileShorthandByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileShorthands = _.get(action, "payload", []);
      })
      .addCase(listProfileShorthandByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileShorthand
      .addCase(addProfileShorthand.pending, (state) => {
        state.isLoadingAddProfileShorthand = true;
        state.addProfileShorthandError = null;
      })
      .addCase(addProfileShorthand.fulfilled, (state, action) => {
        state.isLoadingAddProfileShorthand = false;
      })
      .addCase(addProfileShorthand.rejected, (state, action) => {
        state.isLoadingAddProfileShorthand = false;
        state.addProfileShorthandError = action.payload;
      })
      // editProfileShorthand
      .addCase(editProfileShorthand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileShorthand.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editProfileShorthand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfileShorthand
      .addCase(removeProfileShorthand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileShorthand.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfileShorthand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileShorthandReducer = profileShorthandSlice.reducer;

export const profileShorthandAction = profileShorthandSlice.actions;
